import React, { useContext, useEffect, useState } from 'react'
import { AuthContext, ThemeContext } from '../../../auth';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Button, Dropdown } from 'react-bootstrap';
import { BsGearFill } from 'react-icons/bs';
import { CiLogout } from 'react-icons/ci';
import mySound from '../../../assets/notificattion/notification.mp3'
import useSound from 'use-sound';
import { axiosAuth } from '../../../api';
import { IoIosNotifications } from 'react-icons/io';

function HeaderNotifSales() {

    const { setUserInfo, accessToken, setAccessToken, userInfo } = useContext(AuthContext);
    const { theme } = useContext(ThemeContext);
    const [listDeniedPcp, setListDeniedPcp] = useState([]);
    const [previousListDeniedPcp, setPreviousListDeniedPcp] = useState([]);
    const [playSound] = useSound(mySound);

    const navigate = useNavigate();

    const retrieveDeniedPcp = () => {

        axiosAuth.get(`/api/leads?userId=${userInfo?.id}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                const filterData = res.data.data.filter(item => item?.pcpStatus === "denied" && item.status != 0);

                setListDeniedPcp(filterData);

            }).catch(err => {
                console.error(err);

                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Gagal memuat data, coba kembali beberapa saat lagi!',
                });

            })
    };

    useEffect(() => {
        if (accessToken !== undefined) retrieveDeniedPcp();
    }, [accessToken]);

    useEffect(() => {
        let lastMinute = new Date().getMinutes();
        const intervalId = setInterval(() => {
            const now = new Date();
            const currentMinute = now.getMinutes();

            if (currentMinute !== lastMinute) {
                lastMinute = currentMinute;
                if (accessToken && userInfo?.id) {
                    retrieveDeniedPcp(false);  // no loading spinner
                }
            }
        }, 1000);

        return () => clearInterval(intervalId);
    }, [accessToken, userInfo?.id]);

    useEffect(() => {

        if (JSON.stringify(listDeniedPcp) !== JSON.stringify(previousListDeniedPcp)) {

            playSound();

            Swal.fire({
                icon: 'info',
                title: 'Ada PCP yang ditolak!',
                showConfirmButton: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    setPreviousListDeniedPcp(listDeniedPcp.slice());
                }
            });
        }
    }, [listDeniedPcp, previousListDeniedPcp]);


    const handleSubmitLogout = async () => {
        const confirmDelete = await Swal.fire({
            title: 'Apakah anda yakin ingin keluar dari aplikasi?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Keluar',
            cancelButtonText: 'Batal',
        });

        if (!confirmDelete.isConfirmed) {

            return;
        }

        try {
            await axiosAuth.post(
                '/api/auth/logout',
                {},
                {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        withCredentials: true,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            sessionStorage.removeItem('userInfo');
            sessionStorage.removeItem('accessToken');
            setUserInfo();
            setAccessToken();

            Swal.fire({
                icon: 'success',
                title: 'Proses keluar berhasil!',
                showConfirmButton: false,
                timer: 2000,
            });
            navigate('/');
        } catch (error) {
            console.error(error)
            Swal.fire({
                icon: 'error',
                title: 'Warning!',
                text: 'Proses keluar gagal!',
            });
        }
    };

    return (
        <>
            <span className="container-logout-web" style={{ fontFamily: 'Poppins-Regular' }}>
                <Dropdown drop='start' style={{ marginRight: '0px' }}>
                    <Dropdown.Toggle variant="btn" data-bs-theme={theme === 'light' ? 'dark' : ''} style={{ borderRadius: '0px', border: 'none', boxShadow: 'none' }}>
                        <IoIosNotifications size={22} color={theme === 'light' ? '#FFFFFF' : '#222222'} />
                        {
                            listDeniedPcp?.length === 0 ? (
                                <></>
                            ) : (
                                <div
                                    id='customBadge'
                                    style={{
                                        fontFamily: 'Poppins-Regular',
                                        backgroundColor: theme === 'light' ? '#12B3ED' : '#2f4b7c',
                                        color: theme === 'light' ? '#121212' : '#FFFFFF',
                                    }}
                                >
                                    {listDeniedPcp?.length || 0}
                                </div>
                            )
                        }
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                        id={theme === 'light' ? 'dropdownMenuDark' : 'dropdownMenuLight'}
                        style={{ overflowY: 'auto', maxHeight: '200px' }}
                    >
                        {
                            listDeniedPcp.map((data, index) => {

                                return (
                                    <Dropdown.Item
                                        id={theme === 'light' ? 'dropdownItem1Dark' : 'dropdownItem1Light'}
                                        className="d-flex align-items-center justify-content-center my-3"
                                        key={index}
                                        style={{ cursor: 'default' }}
                                    >
                                        <div
                                            style={{
                                                color: theme === 'light' ? '#FFFFFF' : '#707070',
                                                display: 'flex',
                                                alignItems: 'center',
                                                borderBottom: theme === 'light' ? '2px dashed #FFFFFF' : '2px dashed #000A2E'
                                            }}
                                        >
                                            <p className="mb-3" style={{ margin: 0, marginRight: '10px' }}>
                                                {data?.noLead}
                                            </p>
                                        </div>
                                    </Dropdown.Item>
                                )
                            })
                        }
                    </Dropdown.Menu>
                </Dropdown>

                <Dropdown drop='start' style={{ marginLeft: '0px' }}>
                    <Dropdown.Toggle variant="btn" data-bs-theme={theme === 'light' ? 'dark' : ''} style={{ borderRadius: '0px', border: 'none', boxShadow: 'none' }}>
                        <BsGearFill size={18} color={theme === 'light' ? '#FFFFFF' : '#222222'} />
                    </Dropdown.Toggle>
                    <Dropdown.Menu id={theme === 'light' ? 'dropdownMenuDark' : 'dropdownMenuLight'}>
                        <Dropdown.Item
                            id={theme === 'light' ? 'dropdownItem1Dark' : 'dropdownItem1Light'}
                            className="d-flex align-items-center justify-content-center my-3"
                            onClick={handleSubmitLogout}
                        >
                            <CiLogout size={25} className='me-2' color={theme === 'light' ? '#FFFFFF' : '#707070'} />
                            <span style={{ fontFamily: 'Poppins-Light', color: theme === 'light' ? '#FFFFFF' : '#707070' }}>Keluar</span>
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </span>
        </>
    )
}

export default HeaderNotifSales
